import React from "react";

interface ButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
  type: "button" | "submit" | "reset";
  disabled?: boolean;
  variant?:
    | "primary"
    | "secondary"
    | "danger"
    | "pimaryOutline"
    | "secondaryOutline"
    | "dangerOutline"
    | "gray"
    | "success"
    | "lightGray";
    
}

export const BasicButton: React.FC<ButtonProps> = ({
  children,
  className,
  type,
  onClick,
  disabled = false,
  variant = "primary",
}) => {
  const variantClass = {
    primary:
      "btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20",
    secondary:
      "text-white bg-green-500 border-green-500 btn hover:text-white hover:bg-green-600 hover:border-green-600 focus:text-white focus:bg-green-600 focus:border-green-600 focus:ring focus:ring-green-100 active:text-white active:bg-green-600 active:border-green-600 active:ring active:ring-green-100 dark:ring-green-400/10",
    danger:
      "text-white bg-red-500 border-red-500 btn hover:text-white hover:bg-red-600 hover:border-red-600 focus:text-white focus:bg-red-600 focus:border-red-600 focus:ring focus:ring-red-100 active:text-white active:bg-red-600 active:border-red-600 active:ring active:ring-red-100 dark:ring-custom-400/20",
    pimaryOutline:
      "bg-white text-custom-500 btn border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:bg-zink-700 dark:hover:bg-custom-500 dark:ring-custom-400/20 dark:focus:bg-custom-500",

    secondaryOutline:
      "text-green-500 bg-white border-green-500 btn hover:text-white hover:bg-green-600 hover:border-green-600 focus:text-white focus:bg-green-600 focus:border-green-600 focus:ring focus:ring-green-100 active:text-white active:bg-green-600 active:border-green-600 active:ring active:ring-green-100 dark:bg-zink-700 dark:hover:bg-green-500 dark:ring-green-400/20 dark:focus:bg-green-500",

    dangerOutline:
      "text-red-500 bg-white border-red-500 btn hover:text-white hover:bg-red-600 hover:border-red-600 focus:text-white focus:bg-red-600 focus:border-red-600 focus:ring focus:ring-red-100 active:text-white active:bg-red-600 active:border-red-600 active:ring active:ring-red-100 dark:bg-zink-700 dark:hover:bg-red-500 dark:ring-red-400/20 dark:focus:bg-red-500",
      gray: "text-white bg-gray-500 border-gray-500 btn hover:bg-gray-600 focus:bg-gray-600 focus:border-gray-600 focus:ring focus:ring-gray-100 active:bg-gray-600 active:border-gray-600", 
      success: "text-white bg-green-600 border-green-600 hover:bg-green-700",

      lightGray: "text-black bg-slate-300 border-slate-300 btn hover:bg-slate-300 focus:bg-slate-300 focus:border-slate-300 focus:ring focus:ring-slate-300 active:bg-slate-300 active:border-slate-300",

  };

  return (
    <button
      type={type}
      className={variantClass[variant] + className}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
